<div class="tw:flex tw:flex-col tw:min-h-screen">
	<app-password-expiry-alert />

	<div class="tw:flex-1 tw:flex">
		<div class="tw:hidden tw:md:block tw:h-screen tw:sticky tw:top-0">
			<app-side-menu-internal-views />
		</div>

		<div class="tw:flex-1 tw:flex tw:flex-col tw:bg-[#f2f2f2]">
			<div class="tw:z-10 tw:sticky tw:top-0">
				<app-topbar [internalView]="true" />
			</div>
			<router-outlet />
		</div>
	</div>
</div>

<app-bottom-menu-internal-view />
